import { Modal, Text, View, type GestureResponderEvent } from 'react-native';
import { SecondaryButton } from 'src/presentation/components/molecules/Button';
import dialogStyles from 'src/presentation/dialogs/styles/DialogStyles';
import { HtmlView } from 'src/presentation/components/organisms/HtmlView';

interface Props {
	buttonText: string;
	buttonTextVerify?: string | null;
	onPress: (event: GestureResponderEvent) => void;
	text: string;
	title?: string | null;
	visible?: boolean | null;
}

const MailResponseDialog = ({ onPress, buttonText, text, title, visible }: Props) => {
	return (
		<Modal animationType="fade" style={dialogStyles.modalView} transparent={true} visible={visible === true}>
			<View style={dialogStyles.centeredView}>
				<View style={dialogStyles.modalCard}>
					<Text style={dialogStyles.modalTitle}>{title}</Text>

					<View style={dialogStyles.modalDescription}>
						<HtmlView html={text} />
					</View>

					<SecondaryButton label={buttonText} onPress={onPress} />
				</View>
			</View>
		</Modal>
	);
};

export default MailResponseDialog;
